<div class="products-family-route lifeislife-header-route">

  <div class="back">
    <a [routerLink]="['/products']"
       class="back-link"
    >
      <i class="fa fa-chevron-left"></i>
      <span>Retour à mes polices</span>
    </a>
  </div>

  <a [routerLink]="['/mandate']"
     class="sticky-button lifeislife-button-link mandate-request-action-button"
  >
    <span i18n>Transférer d'autres contrats vers LifeisLife</span>
  </a>


  <header>
    <h1>Où en suis-je dans mon épargne ?</h1>
  </header>

  <div class="contact-pension-previews">

    <div *ngIf="(pensionProductsModel$ | async) == null; else pensionModelLoaded">
      <p>Chargement des informations relatives aux produits pension...</p>
    </div>

    <ng-template #pensionModelLoaded>
      <p-tabView *ngIf="pensionProductPerContactFeature$ | async; else singleGroup">
        <p-tabPanel *ngFor="let model of pensionProductsModel$ | async"
                    [header]="model.insuredContactName">
          <cf-contact-pension-preview [contactPreviewModel]="model"
          ></cf-contact-pension-preview>
        </p-tabPanel>
      </p-tabView>
      <ng-template #singleGroup>
        <cf-contact-pension-preview [contactPreviewModel]="(pensionProductsModel$ | async)[0]"
                                    *ngIf="(pensionProductsModel$ | async)?.length === 1"
        ></cf-contact-pension-preview>
      </ng-template>
    </ng-template>
  </div>


  <div class="call-to-action">
    <a class="lifeislife-button-link"
       (click)="onInfoRequestDraftCreateClick()">
      Je voudrais plus d'informations sur d'autres produits pension
    </a>
  </div>


  <div class="footer-links">
    <a [routerLink]="['/products', 'RETIREMENT']"
       class="header-subtitle"
    >
      <span i18n>Mes produits PENSION</span>
    </a>
  </div>


  <cf-insurance-request-draft-dialog [ticket]="editingInsuranceInfoReaquestDraf$ | async"
  ></cf-insurance-request-draft-dialog>
</div>
